/* pos/reducer */

import { createReducer } from "typesafe-actions";
import { PosActionTypes, PosState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError
} from "./actions";

export const initialState: PosState = {
  data: undefined,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<PosState, ActionType>(initialState)
  .handleType(PosActionTypes.FETCH, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(PosActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(PosActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload
    };
  })
  .handleType(PosActionTypes.SAVE_REQUEST, state => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(PosActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  })
  .handleType(PosActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
      // data: undefined
    };
  })
  .handleType(PosActionTypes.DELETE_REQUEST, state => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(PosActionTypes.DELETE_SUCCESS, state => {
    return {
      ...state,
      loading: false,
      errors: undefined
    };
  })
  .handleType(PosActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload
    };
  });
